import React, { ReactNode, useEffect, useRef } from "react";
import { PolyIcon } from "elements";

export interface ToolTipProps {
  icon?: string;
  iconPosition?: "left" | "right";
  iconReplacement?: ReactNode;
  title?: string;
  iconTitle: string;
  position?: "top" | "right" | "bottom" | "left";
  className?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "dynamic";
  disablePopup?: boolean;
  hideTextOverflow?: boolean;
  hideTooltipOnClick?: (hideToolTip: boolean) => void;
  testDataId?: string;
}

const ToolTip: React.FC<ToolTipProps> = ({
  disablePopup = false,
  ...props
}) => {
  const self = useRef<HTMLDivElement>(null);
  const { hideTooltipOnClick } = props;

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (!self?.current?.contains(e.target as Node) && hideTooltipOnClick) {
        hideTooltipOnClick(true);
      }
    };

    document.addEventListener("mousedown", handleClick);
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [hideTooltipOnClick]);

  const icon = props.icon || "help_circle";
  const iconPosition = props.iconPosition || "left";
  const title = props.title || "";
  const position = props.position || "top";
  const arrowPositions = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
  };

  const size = props.size || "md";
  const cssClass = props.className || "";

  return (
    <div
      ref={self}
      className={`tooltip ${
        props.hideTooltipOnClick !== undefined ? "no-hover" : "hover"
      } tooltip-${position} icon-${iconPosition} ${cssClass}`}
      data-testid={props?.testDataId}
    >
      {"right" === iconPosition ? title : null}
      {props.iconReplacement ? (
        props.hideTextOverflow ? (
          <div className="tool-tip-text">{props.iconReplacement}</div>
        ) : (
          props.iconReplacement
        )
      ) : (
        <PolyIcon
          onClick={() => {
            if (hideTooltipOnClick) {
              props.hideTooltipOnClick!(false);
            }
          }}
          icon={icon}
          title={props.iconTitle}
          className={`tooltip-icon icon-${iconPosition}`}
        />
      )}
      {"left" === iconPosition ? title : null}
      {disablePopup ? null : (
        <div
          className={`tooltip-message tooltip-${size} arrow-${
            arrowPositions[position]
          } ${
            props.hideTooltipOnClick !== undefined
              ? "scoll-behind-header"
              : null
          }${size === "dynamic" ? " dynamic" : ""}`}
          data-testid={`${props?.testDataId}-tooltip-message`}
        >
          <div className="tooltip-liner">{props.children}</div>
        </div>
      )}
    </div>
  );
};

export default ToolTip;
